import React, { useState } from "react"
import { View, Text, TextInput, TouchableOpacity, Image, StyleSheet, SafeAreaView, Alert } from "react-native"
import axios from "axios"
import Logo from "./assets/DaniLees_Logo.png"
import API_PATHS from "../src/apiCalls/ApiPath"
// import { ToastContainer, toast } from "react-toastify"
// import "react-toastify/dist/ReactToastify.css"

export default function SignUp({ navigation }) {
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [formattedPhone, setFormattedPhone] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [errors, setErrors] = useState({})

  const validateForm = () => {
    const errors = {}
    if (!email) errors.email = "Email is required"
    else if (!/\S+@\S+\.\S+/.test(email)) errors.email = "Email is invalid"
    if (!name) errors.name = "Name is required"
    if (!formattedPhone) errors.phone = "Phone number is required"
    if (!password) errors.password = "Password is required"
    else if (password.length < 6) errors.password = "Password must be at least 6 characters"
    setErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleSignUp = async () => {
    if (validateForm()) {
      try {
        const response = await axios.post(`${API_PATHS.BASE_URL}${API_PATHS.CREATE_PARENT}`, {
          email,
          password,
          phoneNumber: formattedPhone,
          name,
        })
        if (response.status === 200 || response.status === 201) {
          // toast.success("Sign-Up successfully, you must get email at registered email-Id, please verify", {
          //   onClose: () => navigation.navigate("Login"), 
          //   autoClose: 3000,})
          navigation.navigate("Login");
        } else {
          throw new Error("Unexpected response from server")
        }
      } catch (error) {
        let errorMessage = "An unexpected error occurred"
        if (error.response) errorMessage = error.response.data.message || "Error occurred during sign up"
        else if (error.request) errorMessage = "Unable to connect to the server"
        else errorMessage = error.message
        // toast.error(errorMessage)
      }
    } else {
      // toast.error("Validation Error", "Please correct the errors in the form.")
    }
  }

  return (
    <SafeAreaView style={styles.container}>
      {/* <ToastContainer position="top-center" autoClose={3000} /> */}
      <View style={styles.header}>
        <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
          <Image source={require("./assets/back1.png")} style={styles.backIcon} />
        </TouchableOpacity>
        <Text style={styles.headerText}>Create Account</Text>
      </View>
      <View style={styles.content}>
        <Image source={Logo} style={styles.logo} resizeMode="contain" />
        <View style={styles.inputContainer}>
          <TextInput style={[styles.input, errors.email && styles.inputError]} placeholder="E-mail*" value={email} onChangeText={(text) => { setEmail(text); setErrors({ ...errors, email: null }) }} keyboardType="email-address" autoCapitalize="none" />
          {errors.email && <Text style={styles.errorText}>{errors.email}</Text>}
          <TextInput style={[styles.input, errors.name && styles.inputError]} placeholder="Name*" value={name} onChangeText={(text) => { setName(text); setErrors({ ...errors, name: null }) }} />
          {errors.name && <Text style={styles.errorText}>{errors.name}</Text>}
          <TextInput style={[styles.input, errors.phone && styles.inputError]} placeholder="Phone Number*" value={formattedPhone} onChangeText={(text) => { setFormattedPhone(text); setErrors({ ...errors, phone: null }) }} keyboardType="phone-pad" />
          {errors.phone && <Text style={styles.errorText}>{errors.phone}</Text>}
          <View style={styles.passwordContainer}>
            <TextInput style={[styles.input, errors.password && styles.inputError]} placeholder="Password*" value={password} onChangeText={(text) => { setPassword(text); setErrors({ ...errors, password: null }) }} secureTextEntry={!showPassword} />
            <TouchableOpacity style={styles.eyeIcon} onPress={() => setShowPassword(!showPassword)}>
              <Image source={require("./assets/EyeIcon.png")} style={styles.eye} />
            </TouchableOpacity>
          </View>
          {errors.password && <Text style={styles.errorText}>{errors.password}</Text>}
          <TouchableOpacity style={styles.signUpButton} onPress={handleSignUp}>
            <Text style={styles.signUpButtonText}>Sign-Up</Text>
          </TouchableOpacity>
        </View>
      </View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: "#fff" },
  header: { backgroundColor: "#A6CE39", padding: 15, flexDirection: "row", alignItems: "center", justifyContent: "center" },
  backButton: { position: "absolute", left: 20, zIndex: 1 },
  backIcon: { width: 20, height: 20 },
  headerText: { color: "#fff", fontSize: 25, fontWeight: "bold", marginLeft: 10 },
  content: { flex: 1, alignItems: "center", padding: 40 },
  logo: { width: 200, height: 125, marginBottom: 20 },
  inputContainer: { width: "100%", marginTop: 10 },
  input: { borderWidth: 1, borderColor: "#505766", borderRadius: 4, padding: 15, marginBottom: 15, width: "100%", fontSize: 15 },
  inputError: { borderColor: "red" },
  errorText: { color: "red", fontSize: 12, marginBottom: 10 },
  passwordContainer: { position: "relative", marginBottom: 15 },
  eyeIcon: { position: "absolute", right: 15, top: 15 },
  eye: { width: 24, height: 24, tintColor: "#666" },
  signUpButton: { alignSelf: "center", backgroundColor: "#A6CE39", padding: 15, marginTop: 10, width: 200 },
  signUpButtonText: { color: "#fff", textAlign: "center", fontSize: 24, fontWeight: "bold" },
})
